/*!
 * ADYJO Console Protect
 * Prevents casual console tampering and reduces accidental leaks.
 */
(function (window) {
  'use strict';

  function noop() {}

  function init() {
    try {
      if (!window.console) window.console = {};
      var methods = [
        'log', 'info', 'warn', 'error', 'debug', 'trace',
        'table', 'clear', 'dir', 'dirxml', 'group',
        'groupCollapsed', 'groupEnd', 'time', 'timeEnd',
        'count', 'assert', 'profile', 'profileEnd'
      ];

      for (var i = 0; i < methods.length; i++) {
        if (typeof window.console[methods[i]] !== 'function') {
          window.console[methods[i]] = noop;
        }
      }
    } catch (err) {}
  }

  init();
})(window);
